"use strict";
import { createUseModal } from "./createUseModal.js";
import { Modal } from "./Modal.js";
const useModal = createUseModal(Modal);
export {
  Modal,
  useModal
};
